// import packages
import React from "react";

// import hoc
import { withErrorBoundary } from "lib/hoc";

const XhawiPrivacy = () => {
  return (
    <div dangerouslySetInnerHTML={{ __html: `<!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8">
      <title>Xhawi Privacy Policy</title>
      <style>
        body {
          margin: 0;
          font-family: "Segoe UI", Arial, sans-serif;
          line-height: 1.6;
          color: #111;
          background: #fafafa;
          display: flex;
          flex-direction: column;
          min-height: 100vh;
        }
    
        .content {
          flex: 1;
          padding: 40px 50px;
          max-width: 900px;
          margin: auto;
        }
    
        h1 {
          font-size: 32px;
          margin-bottom: 10px;
          color: #000;
          border-bottom: 4px solid #b5f75b;
          padding-bottom: 8px;
        }
    
        h2 {
          margin-top: 30px;
          font-size: 22px;
          color: #000;
          padding-top: 3px;
          padding-bottom: 3px;
        }
    
        p, li {
          font-size: 15px;
          color: #222;
        }
    
        ul {
          margin: 10px 0 20px 40px;
        }
    
        strong {
          color: #000;
        }
    
        .section {
          margin-bottom: 25px;
          position: relative;
        }
    
        .final-note {
          margin-top: 35px;
          padding: 15px;
          background: #b5f75b;
          color: #000;
          font-weight: bold;
          border-radius: 4px;
        }
    
        footer {
          background: #b5f75b;
          color: #000;
          text-align: center;
          padding: 15px;
          font-size: 14px;
          margin-top: 40px;
        }
    
        /* Responsive adjustments */
        @media (max-width: 768px) {
          .content {
            padding: 20px;
          }
          h1 {
            font-size: 26px;
          }
          h2 {
            font-size: 20px;
          }
          p, li {
            font-size: 14px;
          }
          ul {
            margin-left: 25px;
          }
        }
    
        @media (max-width: 480px) {
          .content {
            padding: 15px;
          }
          h1 {
            font-size: 22px;
          }
          h2 {
            font-size: 18px;
          }
          p, li {
            font-size: 13px;
          }
          ul {
            margin-left: 20px;
          }
          footer {
            font-size: 13px;
            padding: 12px;
          }
        }
      </style>
    </head>
    <body>
    
      <div class="content">
        <h1>Privacy Policy</h1>
        <h2>Xhawi Privacy Policy</h2>
        <p>
          This privacy policy describes the ways in which we collect, store, and protect your personal information 
          and it is important for all users of the Service to review this policy. It explains Xhawi (“Xhawi” together 
          with "we," "us," and "our") privacy practices for Xhawi (the "Site") and Xhawi's mobile applications (the "Apps"). 
          We’ll refer to the Site, the Apps, and all other services offered by us or otherwise offered on or through our website as the "Services."
        </p>
    
        <div class="section">
          <h2>Personal Information</h2>
          <p>
            By "Personal Information," we mean information that can be associated with a specific person and can be used to identify that person. 
            We do not consider anonymous information to constitute personal information. 
            We collect personal information from you when you use the Services (including, without limitation, when you buy, sell, or barter items 
            or when you telephone, email, or chat with our customer support team).
          </p>
          <p>
            By providing us with your personal information, you expressly consent to us processing it in accordance with this policy.
          </p>
        </div>
    
        <div class="section">
          <h2>Information We Collect</h2>
          <p>
            To use the Services, you need to provide a valid email address, which will serve as your unique ID. 
            We may collect information about your use of the Services for advertising, analytics, promotional campaigns, 
            and to protect the Services, including IP address, browser information, and device details.
          </p>
          <p>
            Financial information must be entered in the appropriate places on Xhawi when prompted. We use this only for billing 
            and fulfilling your orders. Transactional information is collected based on your activities using the Site 
            and is used solely for your transactions. We may also collect additional information from or about you in other ways not specifically described here.
          </p>
        </div>
    
        <div class="section">
          <h2>Use of Information</h2>
          <p>
            We only use your personal information to provide services and customer support; to measure and improve our services; 
            to prevent illegal activities and enforce our Terms and Conditions; troubleshoot problems; collect fees; 
            provide you with promotional emails; and verify information with third parties.
          </p>
          <p>
            We may also use your information to improve and customize our Services, understand usage patterns, 
            and develop new features. This is necessary to pursue our legitimate interests in improving efficiency, 
            user engagement, and business growth.
          </p>
        </div>
    
        <div class="section">
          <h2>Disclosure of Information</h2>
          <p>
            We may disclose your personal information to law enforcement or government agencies where required by law, 
            to comply with investigations, or where necessary to prevent harm or loss. 
            We may also share your information with group companies to provide joint services or detect illegal acts.
          </p>
          <p>
            We do not sell or rent your personal information to third parties. However, we may share it with trusted 
            service providers (such as payment gateways, logistics partners, and analytics providers) to operate, 
            provide, and market our Services.
          </p>
          <p>
            In the event of a sale or transfer of Xhawi or its assets, your information may be disclosed to the potential purchaser 
            to ensure continued provision of Services.
          </p>
        </div>
    
        <div class="section">
          <h2>Communication & Consent</h2>
          <p>
            By registering on the Site, you may opt-in to receive promotional emails about our Services and announcements. 
            You can opt out at any time.
          </p>
          <p>
            During transactions, Xhawi facilitates sharing of necessary information between users (e.g., shipping address and payment details). 
            You must respect the privacy of other users and only use their information for Xhawi-related transactions.
          </p>
        </div>
    
        <div class="section">
          <h2>Third-Party Services</h2>
          <p>
            Xhawi engages third-party companies (payment gateways, logistics, research, analytics, and security providers) 
            to help us operate. These parties have limited access to your information and may only use it on our behalf.
          </p>
          <p>
            Credit/debit card details submitted while making payments are not stored on Xhawi but handled by our payment gateway partners.
          </p>
        </div>
    
        <div class="section">
          <h2>Data Accuracy & Retention</h2>
          <p>
            If your personal information changes, you should update it via the My Account section or by contacting customer support. 
            We retain personal information as required by law, for troubleshooting, fraud prevention, legal investigations, 
            or other lawful purposes.
          </p>
        </div>
    
        <div class="section">
          <h2>Third-Party Links</h2>
          <p>
            The Site may contain links to other websites. We are not responsible for the privacy practices of such sites. 
            We encourage you to read their privacy policies when visiting them.
          </p>
        </div>
    
        <div class="section">
          <h2>Cookies</h2>
          <p>
            Like many websites, Xhawi uses 'cookies' (small files placed on your device). Cookies help improve your experience 
            and allow us to understand site usage. They do not reveal personal information. You can decline cookies in your browser, 
            though it may affect site functionality.
          </p>
        </div>
    
        <div class="section">
          <h2>Security</h2>
          <p>
            We safeguard personal information from unauthorized access using encryption and secure systems. 
            However, no system is completely secure. You must protect your username and password and contact support if compromised.
          </p>
        </div>
    
        <div class="section">
          <h2>Policy Updates</h2>
          <p>
            We may amend this privacy policy at any time by posting a revised version on the Site. 
            Continued use of the Site constitutes consent to the revised policy. Please check the Site regularly for updates.
          </p>
        </div>
    
        <div class="final-note">
          If you have questions or concerns about our collection and use of your personal information, contact us at <strong>care@xhawi.com</strong>
        </div>
      </div>
    </body>
    </html>
    ` }} />
  );
};

export default withErrorBoundary(XhawiPrivacy);
